<template>
  <div>
    <!-- modal -->

    <!-- BODY -->
    <validation-observer
      #default="{ handleSubmit }"
      ref="refFormObserver"
    >
      <!-- Form -->
      <b-form
        @submit.prevent="handleSubmit(saveData)"
        @reset.prevent="resetForm"
      >
        <validation-provider
          #default="validationContext"
          :name="$t('Üst Kategori')"
          rules="required"
        >
          <b-form-group
            v-if="brandData"
            :label="$t('Üst Kategori')"
            label-for="parent_Brand"
          >
            <v-select
              id="parent_Brand"
              v-model="brandData.parent_Brand"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="label"
              :reduce="val => val.value"
              :clearable="false"
              :selectale="brandData.creator==1"
              :options="caegoriesData"
              :state="getValidationState(validationContext)"
            />

            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
        <validation-provider
          #default="validationContext"
          :name="$t('Kategori Adı')"
          rules="required|min:2"
        >
          <b-form-group
            :label="$t('Kategori Adı')"
            label-for="name"
          >
            <b-form-input
              id="name"
              v-model="brandData.name"
              autofocus
              autocomplete="off"
              :readonly="brandData.creator!=1"
              :state="getValidationState(validationContext)"
              trim
            />

            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <hr>
        <b-alert
          v-if="brandData.creator!=1"
          variant="warning"
          show
        >
          <div class="alert-body">
            <span>{{ $t('Bu Veri Sistem Tarafından Otomatik Oluşturulduğu İçin Düzenlenemez ve Silinemez') }}</span>
          </div>
        </b-alert>
        <div class="d-flex align-items-center justify-content-end">
          <b-button
            v-if="brandData.creator==1"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            type="submit"
          >
            {{ $t('Kaydet') }}
          </b-button>
        </div>

      </b-form>
    </validation-observer>

  </div>
</template>

<script>
import {
  BForm, BFormGroup, BButton, VBModal, BAlert, BFormInput, BFormInvalidFeedback,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import countries from '@/@fake-db/data/other/countries'
import store from '@/store'
import i18n from '@/libs/i18n'
import vSelect from 'vue-select'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BFormInvalidFeedback,
    // eslint-disable-next-line vue/no-unused-components
    vSelect,
    BAlert,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  model: {
    prop: 'modalShow',
    event: 'update:customer-manager-edit-modal-show',
  },

  props: {
    selectedBrand: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
      countries,
      blankbrandData: {
        name: '',
        name_en: '',
        parent_Brand: 0,
        creator: 1,
      },
      componentMode: 'add',
      brandData: {},
      showManagerTitleEditor: false,
      managerTitlesData: [],
      managersData: [],
      selectedIndex: -1,
      createdBySystem: false,
    }
  },
  watch: {
  },
  created() {
    if (this.selectedBrand != null) {
      this.componentMode = 'edit'
    } else {
      this.componentMode = 'add'
    }
    if (this.selectedBrand != null) {
      this.blankbrandData = this.selectedBrand
    }
    this.resetbrandData()
  },
  methods: {
    showSuccessMessage() {
      this.$bvToast.toast(this.$t('İşlem Başarılı'), {
        title: this.$t('İşlem Başarılı'),
        variant: 'success',
        solid: false,
      })
    },
    showErrorMessage() {
      this.$bvToast.toast(this.$t('İşlem Başarısız'), {
        title: this.$t('İşlem Başarısız'),
        variant: 'danger',
        solid: false,
      })
    },

    saveData() {
      if (this.componentMode === 'add') {
        store.dispatch('app-p-product/addBrand', this.brandData)
          // eslint-disable-next-line no-unused-vars
          .then(response => {
            this.resetbrandData()
            this.$emit('dataChanged')
          })
      } else if (this.componentMode === 'edit') {
        store.dispatch('app-p-product/updateBrand', this.brandData)
          .then(() => {
            this.resetbrandData()
            this.$emit('dataChanged')
          })
      }
    },
    resetModal() {},
    resetbrandData() {
      this.brandData = JSON.parse(JSON.stringify(this.blankbrandData))
      this.selectedIndex = -1
    },
  },
  // eslint-disable-next-line no-unused-vars
  setup(props, { emit }) {
    const caegoriesData = ref([{ label: i18n.t('Üst Kategori Yok'), value: 0 }])
    store
      .dispatch('app-p-product/fetchCategories', {
        list_type: 'all',
      })
      .then(response => {
        const { data } = response.data
        const arr = [{ label: i18n.t('Üst Kategori Yok'), value: 0 }]
        data.forEach(val => {
          arr.push({ label: val.name_with_parents, value: val.id })
        })
        caegoriesData.value = arr
      })
    const onSubmit = () => {
    }
    const resetbrandData = () => {
      this.brandData.value = JSON.parse(JSON.stringify(this.blankbrandData))
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetbrandData)

    return {
      onSubmit,
      refFormObserver,
      getValidationState,
      resetForm,
      caegoriesData,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
